import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/MasterData/CompanyBusinessCategory/add'
import { v3_add_company_business_category } from '../../../actions/v3/masterData'
import constant from '../../../constant'
import { toast } from 'react-toastify'
const Add = (props) => {

    const onSubmit = (model) => {
        v3_add_company_business_category(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listCompanyBusinessCategoryMasterData.url)
            }
            else {
                toast.error(res.error)

            }
        })
    }
    return (
        <React.Fragment>
            <Layout
                title={'Add Company Business Category'}
            >
                <Form
                    title={'Add Company Business Category'}
                    onSubmit={onSubmit}
                    buttonName={'Create Company Business Category'}
                />
            </Layout>
        </React.Fragment>
    )
}

export default Add